import React from "react";
import { Link } from "react-router-dom";
import Reveal from "./reveal";

/** Service tile. `long` shows the longer description. */
export default function ServiceCard({ service, long = false, delay = 0 }) {
  return (
    <Reveal delay={delay}>
      <Link to={`/services/${service.slug}`} className="card service-card">
        <div className="card-icon">{service.icon}</div>
        <h3>{service.title}</h3>
        <p>{long ? service.text : service.short}</p>
        <span className="go">Explore Service</span>
      </Link>
    </Reveal>
  );
}
